import { borderRadius, lineHeight, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 12px;
`;

export const PriceWrapper = styled.div<{ $isPrimary: boolean }>`
  display: flex;
  align-items: baseline;
  gap: 8px;

  ${props =>
    props.$isPrimary
      ? css`
          ${Price} {
            ${typographyV2.titleLg}
          }
        `
      : css`
          ${Price} {
            ${typographyV2.titleMd}
            ${lineHeight.l400}
          }
        `}
`;

export const Price = styled.span`
  font-family: var(--font-roboto-mono);
`;

export const Currency = styled.span`
  ${typographyV2.bodyXs}
  text-transform: uppercase;
`;

export const CircleStamp = styled.div<{
  $color: string;
}>`
  width: 6px;
  height: 6px;
  ${borderRadius.rFull}
  background-color: ${({ $color }) => $color};
`;

export const SquareStamp = styled.div<{
  $color: string;
}>`
  width: 6px;
  height: 6px;
  background-color: ${({ $color }) => $color};
`;

const priceChangeColors = {
  default: 'var(--text-soft)',
  negative: 'var(--viz-bearish)',
  positive: 'var(--viz-bullish)',
};

export const PriceChangeContainer = styled.div<{
  $status: 'default' | 'positive' | 'negative';
}>`
  display: flex;
  gap: 8px;
  color: ${props => priceChangeColors[props.$status]};
  font-family: var(--font-roboto-mono);
  ${typographyV2.bodyXs}
`;
